// Master project index - manages all projects dynamically

// Existing projects
import tonelabData from './projects/tonelab.json';
import moodifyData from './projects/moodify.json';
import foundryData from './projects/foundry.json';
import chibidashData from './projects/chibidash.json';
import sportshipData from './projects/the-sportship.json';
import najdarData from './projects/najdar.json';

// New projects
import findbrandvoiceData from './projects/findbrandvoice.json';
import onepiecequizData from './projects/onepiecequiz.json';
import pawtimoData from './projects/pawtimo.json';
import proveItData from './projects/prove-it.json';
import tamAljanubData from './projects/tam-aljanub.json';
import logoBuilderData from './projects/logo-builder.json';
import pudeucData from './projects/pudeuc.json';
import riyalbusinessData from './projects/riyalbusiness.json';
import summitData from './projects/summit.json';
import stashData from './projects/stash.json';

// All projects array - organized by featured first, then by status
export const allProjects = [
  tonelabData,
  findbrandvoiceData,
  proveItData,
  logoBuilderData,
  stashData,
  moodifyData,
  foundryData,
  pudeucData,
  riyalbusinessData,
  summitData,
  najdarData,
  sportshipData,
  tamAljanubData,
  chibidashData,
  onepiecequizData,
  pawtimoData
];

// Hidden projects (not finished yet - kept for later)
// atlasData, brainRotData, dailyGratitudeData, ecoimpactData,
// forlandingpageData, payrollSystemData, privacyvaultData

// Get featured projects
export const getFeaturedProjects = () => {
  return allProjects.filter(project => project.featured);
};

// Get project by slug
export const getProjectBySlug = (slug) => {
  return allProjects.find(project => project.slug === slug);
};

// Get projects by category
export const getProjectsByCategory = (category) => {
  if (category === 'All') return allProjects;
  return allProjects.filter(project => project.category === category);
};

// Get all unique categories
export const getAllCategories = () => {
  const categories = new Set(allProjects.map(project => project.category));
  return ['All', ...Array.from(categories)];
};

// Get projects by status
export const getProjectsByStatus = (status) => {
  return allProjects.filter(project => project.status === status);
};
